export default function WhoIsThisForSection() {
  const goodFit = [
    { icon: "ri-flight-takeoff-line", text: "Travelers with a trip in 1–8 weeks — standard government processing won't make it in time" },
    { icon: "ri-passport-line", text: "Anyone whose passport expired — don't risk the 4–6 week government timeline with a trip coming up" },
    { icon: "ri-briefcase-line", text: "Business travelers — last-minute international meetings require same-week solutions" },
    { icon: "ri-calendar-close-line", text: "People who can't get a passport agency appointment — agency slots are booked 2–4 weeks out in 2026" },
    { icon: "ri-group-line", text: "Families with children needing passports — child passport processing has added in-person requirements we handle" },
    { icon: "ri-map-pin-line", text: "Anyone who lives far from a passport agency — Tampa, Charlotte, Nashville, Louisville, Sacramento, Denver residents don't have a nearby agency" },
    { icon: "ri-alert-line", text: "People who've tried the post office and are worried — if you already mailed your application and it's not moving, we can help escalate" },
  ];

  const notFit = [
    { icon: "ri-close-circle-line", text: "People traveling in more than 8 weeks with no urgency — standard government processing is fine" },
    { icon: "ri-close-circle-line", text: "People traveling in the next 24–48 hours — we can sometimes help but contact us first at 877-253-0084" },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Is This You?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Who Should Use an <span className="text-[#F6C344]">Expedited Passport Service?</span>
          </h2>
        </div>

        <div className="mb-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {goodFit.map((item, i) => (
              <div key={i} className="flex items-start gap-3 p-4 rounded-lg bg-green-50/70 border border-green-100">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-100 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-green-700 text-sm`}></i>
                </div>
                <span className="text-gray-700 text-sm leading-snug">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-amber-50/70 border border-amber-100 rounded-xl p-6 md:p-8">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-4">Who this is NOT for</h3>
          <div className="space-y-3">
            {notFit.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-amber-200 flex-shrink-0">
                  <i className={`${item.icon} text-amber-800 text-sm`}></i>
                </div>
                <span className="text-gray-600 text-sm leading-snug">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Not sure which service you need? We'll help you figure it out.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}